// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 40079) return "static/chunks/" + chunkId + "-c705eaa536da1019.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19939":"a57825cd14336087","64047":"e677631fce0d84a1","78774":"39dc67f53a4ea679"}[chunkId] + ".js";
};